import { useInfiniteSessionParticipations } from 'queries';
import { Participation, getStatusListForColumn } from '@app/api';
import { useMemo, useEffect } from 'react';

export const useParticipationIndexInColumn = (
  sessionId: string,
  participation?: Participation,
): [number, Participation[]] => {
  const participationId = participation && participation.id;

  const { data, fetchNextPage, hasNextPage } = useInfiniteSessionParticipations(
    sessionId,
    getStatusListForColumn(participation && participation.status),
  );

  const participations = useMemo(() => {
    if (!data) return [];
    const list: Participation[] = [];
    data.pages.forEach((page) => {
      page.data.forEach((p) => {
        list.push(p);
      });
    });
    return list;
  }, [data]);

  const selectedIndex = useMemo(() => {
    return participations.findIndex(({ id }) => id === participationId);
  }, [participations, participationId]);

  useEffect(() => {
    if (!hasNextPage) {
      return;
    }
    if (selectedIndex === participations.length - 1 || selectedIndex === -1) {
      fetchNextPage();
    }
  }, [participations, selectedIndex, fetchNextPage, hasNextPage]);

  return [selectedIndex, participations];
};
